module.exports = __webpack_public_path__ + "static/img/fish15.946ee88.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/starfish/fish15.png
// module id = JSAn
// module chunks = 0